export * from './dokumente.querys.module';
